export default {
    "language": "Язык",
    "title": "Киноман",
}
